import { TenantDriverDto } from '@splitsecondconnect/ultramarine-shared';

import { dateCast } from '../functions/sectionCasters.function';

export function mapDriverDtoToModel(x: TenantDriverDto | null): any {
	if (!x) {
		return {
			driverId: null,
			driverIdentityDocumentType: null,
			driverIdentityDocumentNumber: null,
			driverIdentityDocumentIssueDate: null,
			driverIdentityDocumentExpiryDate: null,
			driverIdentityDocumentIssuedByCountryId: null,
			driverDrivingLicenses: [],
			driverDrivingLicenseNumber: null,
			driverDrivingLicenseCategory: null,
			driverDrivingLicenseIssueDate: null,
			driverDrivingLicenseExpiryDate: null,
			driverDrivingLicenseIssuedByCountryId: null,
		};
	}

	const drivingLicenses =
		x.drivingLicenses?.map((license) => ({
			id: license.id ?? null,
			number: license.number ?? null,
			category: license.category ?? null,
			issueDate: dateCast(license.issueDate),
			expiryDate: dateCast(license.expiryDate),
			issuedByCountryId: license.issuedByCountryId ?? null,
			isPrimary: Boolean(license.isPrimary),
		})) ?? [];

	const primaryDrivingLicense =
		drivingLicenses.find((license) => license.isPrimary) ??
		drivingLicenses[0] ??
		null;

	return {
		driverId: x.id,
		driverIdentityDocumentType: x.identityDocumentType ?? null,
		driverIdentityDocumentNumber: x.identityDocumentNumber ?? null,
		driverIdentityDocumentIssueDate: dateCast(x.identityDocumentIssueDate),
		driverIdentityDocumentExpiryDate: dateCast(x.identityDocumentExpiryDate),
		driverIdentityDocumentIssuedByCountryId:
			x.identityDocumentIssuedByCountryId ?? null,
		driverDrivingLicenses: drivingLicenses,
		driverDrivingLicenseNumber: primaryDrivingLicense?.number ?? null,
		driverDrivingLicenseCategory: primaryDrivingLicense?.category ?? null,
		driverDrivingLicenseIssueDate: dateCast(primaryDrivingLicense?.issueDate),
		driverDrivingLicenseExpiryDate: dateCast(primaryDrivingLicense?.expiryDate),
		driverDrivingLicenseIssuedByCountryId:
			primaryDrivingLicense?.issuedByCountryId ?? null,
	};
}

export function mapDriverModelToDto(x: any): any {
	const drivingLicenses = (x.driverDrivingLicenses ?? []).map((license) => ({
		id: license.id ?? null,
		number: license.number ?? null,
		category: license.category ?? null,
		issueDate: dateCast(license.issueDate),
		expiryDate: dateCast(license.expiryDate),
		issuedByCountryId: license.issuedByCountryId ?? null,
		isPrimary: Boolean(license.isPrimary),
	}));

	if (
		drivingLicenses.length === 0 &&
		(x.driverDrivingLicenseNumber ||
			x.driverDrivingLicenseCategory ||
			x.driverDrivingLicenseIssueDate ||
			x.driverDrivingLicenseExpiryDate ||
			x.driverDrivingLicenseIssuedByCountryId)
	) {
		drivingLicenses.push({
			id: null,
			number: x.driverDrivingLicenseNumber ?? null,
			category: x.driverDrivingLicenseCategory ?? null,
			issueDate: dateCast(x.driverDrivingLicenseIssueDate),
			expiryDate: dateCast(x.driverDrivingLicenseExpiryDate),
			issuedByCountryId: x.driverDrivingLicenseIssuedByCountryId ?? null,
			isPrimary: true,
		});
	}

	return {
		driver: {
			id: x.driverId,
			identityDocumentType: x.driverIdentityDocumentType ?? null,
			identityDocumentNumber: x.driverIdentityDocumentNumber ?? null,
			identityDocumentIssueDate: dateCast(x.driverIdentityDocumentIssueDate),
			identityDocumentExpiryDate: dateCast(x.driverIdentityDocumentExpiryDate),
			identityDocumentIssuedByCountryId:
				x.driverIdentityDocumentIssuedByCountryId ?? null,
			drivingLicenses: drivingLicenses,
		},
	};
}

export function mapDriverIdToDriverDto(driverIds: number[]): {
	drivers: TenantDriverDto[];
} {
	const result = driverIds?.map((id) => {
		return {
			id: id,
		};
	});
	return {
		drivers: result,
	};
}
